document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('KyraQuickView');
  const content = document.getElementById('KyraQuickViewContent');

  if (!modal || !content) return;

  function formatMoney(cents) {
    const value = Number(cents) / 100;

    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

let qvScrollY = 0;

function closeQuickView() {
  modal.hidden = true;
  document.body.classList.remove('qv-lock');

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  window.scrollTo(0, qvScrollY);

  content.innerHTML = '';
}

function openQuickView() {
  qvScrollY = window.scrollY || window.pageYOffset;

  modal.hidden = false;
  document.body.classList.add('qv-lock');

  document.body.style.position = 'fixed';
  document.body.style.top = `-${qvScrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
}

  function bindQuickViewInteractions(scope) {
    const variantButtons = scope.querySelectorAll('.pc-variant-btn');
    const galleries = scope.querySelectorAll('.pc-variant-gallery');

    const colorName = scope.querySelector('.qv-color-name, [data-color-current]');
    const variantInput = scope.querySelector('.qv-variant-input');

    const productPrice = scope.querySelector('.qv-product-price');
    const comparePrice = scope.querySelector('.qv-compare-price');
    const klarnaInstallment = scope.querySelector('.qv-klarna-installment');

    const colorCylinder = scope.querySelector('[data-color-cylinder]');
    const colorNext = scope.querySelector('[data-color-next]');
    const colorCurrent = scope.querySelector('[data-color-current]');
    const colorOptions = colorCylinder
      ? Array.from(colorCylinder.querySelectorAll('[data-color-option]'))
      : [];

    let colorIndex = Math.max(
      0,
      colorOptions.findIndex((option) => option.dataset.active === 'true')
    );

    function updateVariant(button) {
      if (!button) return;

      const variantId = button.dataset.variantId;
      const variantPrice = button.dataset.variantPrice;
      const variantCompare = button.dataset.variantCompare;
      const variantTitle = button.dataset.variantTitle;

      variantButtons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      galleries.forEach((gallery) => {
        gallery.classList.toggle('active', gallery.dataset.variantId === variantId);
      });

      if (colorName && variantTitle) {
        colorName.textContent = variantTitle;
      }

      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      if (productPrice && variantPrice) {
        productPrice.textContent = formatMoney(variantPrice);
      }

      if (comparePrice) {
        if (variantCompare && Number(variantCompare) > Number(variantPrice)) {
          comparePrice.textContent = formatMoney(variantCompare);
          comparePrice.style.display = '';
        } else {
          comparePrice.textContent = '';
          comparePrice.style.display = 'none';
        }
      }

      if (klarnaInstallment && variantPrice) {
        klarnaInstallment.textContent = formatMoney(Math.round(Number(variantPrice) / 3));
      }

      colorIndex = Math.max(
        0,
        colorOptions.findIndex((option) => option.dataset.variantId === variantId)
      );
    }

    function selectColorByIndex(newIndex) {
      if (!colorOptions.length) return;

      colorIndex = (newIndex + colorOptions.length) % colorOptions.length;

      const option = colorOptions[colorIndex];
      const variantId = option.dataset.variantId;

      const matchingButton = scope.querySelector(
        `.pc-variant-btn[data-variant-id="${variantId}"]`
      );

      if (colorCurrent) {
        colorCurrent.classList.add('is-changing');

        setTimeout(() => {
          colorCurrent.textContent = option.dataset.variantTitle;
          colorCurrent.classList.remove('is-changing');
        }, 160);
      }

      if (matchingButton) {
        updateVariant(matchingButton);

        matchingButton.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        updateVariant(button);

        const scrollTarget =
          scope.closest('.qv-modal__content') ||
          document.getElementById('KyraQuickViewContent');

        if (scrollTarget) {
          scrollTarget.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      });
    });

    if (colorNext) {
      colorNext.addEventListener('click', () => {
        selectColorByIndex(colorIndex + 1);
      });
    }

    const form = scope.querySelector('.qv-product-form');

    if (form) {
      form.addEventListener('submit', () => {
        setTimeout(closeQuickView, 250);
      });
    }
  }

  async function loadQuickView(handle) {
    if (!handle) return;

    content.innerHTML = '<div class="qv-loading">Caricamento...</div>';
    openQuickView();

    try {
      const response = await fetch(`/products/${handle}?view=quick-view`);
      if (!response.ok) throw new Error('Errore quick view');

      const html = await response.text();
      content.innerHTML = html;

      bindQuickViewInteractions(content);
    } catch (error) {
      console.error(error);
      content.innerHTML = '<div class="qv-error">Si è verificato un errore. Riprova.</div>';
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-product-handle]');

    if (trigger) {
      event.preventDefault();
      loadQuickView(trigger.dataset.productHandle);
      return;
    }

    if (event.target.closest('[data-qv-close]')) {
      closeQuickView();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeQuickView();
    }
  });
});